import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { getInvoiceOrigin } from '../../../core';
import { getCheckUnusedInvoices, getGraph } from '../../../core';
import { DecisionTree } from './decision-tree';
import { ScoreAlg } from './score-alg';
// import { CustomLoader } from '../../../components/basic/loader';

// todo back button functionality

export const ExaminationStart = (props: { type: 'des_t' | 'score' }) => {
  const navigate = useNavigate();
  const { productId, refNumber, invoiceId, diagnosisId } = useParams();
  const [dataa, setDataa] = useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    edges: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vertices: any[];
  }>({
    edges: [],
    vertices: []
  });
  const [dataaS, setDataaS] = useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    questions: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    results: any[];
  }>({
    questions: [],
    options: [],
    results: []
  });

  useEffect(() => {
    if (productId) {
      (async () => {
        try {
          const res = await getCheckUnusedInvoices(parseInt(diagnosisId ?? '-1'));
          if (res.status === 200) {
            if (!res.data.invoice) {
              navigate('/examination');
            }
          }
          const { data, status } = await getGraph(productId, props.type);
          if (status === 200) {
            setDataa(data.data);
            setDataaS(data);
          }
        } catch (e) {
          console.log(e);
        }
      })();
    } else {
      navigate('/examination');
    }
  }, [productId, props.type]);

  return (
    <>
      {props.type === 'des_t' ? (
        <DecisionTree
          data={dataa}
          productId={parseInt(productId ?? '-1')}
          invoiceId={parseInt(invoiceId ?? '-1')}
          refNumber={refNumber ?? ''}
        />
      ) : null}
      {props.type === 'score' ? (
        <ScoreAlg
          data={dataaS}
          productId={parseInt(productId ?? '-1')}
          invoiceId={parseInt(invoiceId ?? '-1')}
          refNumber={refNumber ?? ''}
        />
      ) : null}
    </>
  );
};
